import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { Provider } from 'react-redux'
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from 'react-cookie';

import store from "./redux/store.js"
import API_CONFIG from './js/API/config.js'

import './css/App.css';
import './css/Mob.css';
import './css/index.css';
import App from './App.jsx'

// Устанавливаем окружение для API на основе режима Vite
const viteMode = import.meta.env.MODE === 'production' ? 'prod' : 'dev';
API_CONFIG.setEnvironment(viteMode);

createRoot(document.getElementById('root')).render(

		<Provider store={store}>
			<BrowserRouter basename="/snreg">
				<CookiesProvider>
        				<App />
      				</CookiesProvider>
			</BrowserRouter>
		</Provider>

);
